import platform from "platform";

export function adjustViewportForIOS() {
  const isIOS: boolean = platform.os?.family === "iOS";
  const isSafari: boolean = platform.name === "Safari";
  if (isIOS && isSafari) {
    const viewport: HTMLMetaElement | null = document.querySelector(
      'meta[name="viewport"]',
    );
    if (viewport) {
      const content: string | null = viewport.getAttribute("content");
      if (content && !content.includes("maximum-scale=1")) {
        viewport.setAttribute("content", `${content}, maximum-scale=1`);
      }
    }
  }
}

export function isIOS() {
  return platform.os?.family === "iOS";
}

export function isSafari() {
  return platform.name === "Safari";
}
